var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "boss-button",
        attrs: { "data-test": "button-download" },
        on: { click: _vm.onDownloadClick },
      },
      [
        _c("img", {
          attrs: { src: require("@/assets/images/icon-download.svg"), alt: "" },
        }),
        _vm._v(" "),
        _c("span", [_vm._v("PDFダウンロード")]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }